import { FC, Fragment } from 'react';
import styled from 'styled-components';

type SteeperProps = {
  steps: string[],
  currentStep: number
}
// Estilos para los elementos del progressbar
const ProgressBarContainer = styled.div`
  display: flex;
  align-items: start;
  gap: 20px; /* Espacio entre los pasos */
  position: relative;
`;

const StepCircle = styled.div<{ $status: 'inactive' | 'current' | 'completed' }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: ${({ $status }) => $status === 'inactive' ? 'gray' : 'white'};
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
  background-color: ${({ theme, $status }) => {
    switch ($status) {
      case 'inactive':
        return 'transparent'; // Transparente para inactivo
      case 'current':
        return theme.colors.primary1;
      case 'completed':
        return theme.colors.primary1;
      default:
        return 'transparent';
    }
  }};
`;

const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50px;
`
const StepLabel = styled.span<{ $status: 'inactive' | 'current' | 'completed' }>`
  font-size: 12px;
  color: #333;
  text-align: center;
  margin-top: 1rem;
  font-weight: ${({ theme, $status }) => $status === 'inactive' ? theme.typography.fontWeight.regular : theme.typography.fontWeight.bold} ;
`;

const ProgressLine = styled.div`
  width: 40px;
  height: 6px;
  border-radius: 8px;
  background-color: #ccc;
  margin-top: 18px;
`;

// Componente principal del progressbar
export const Stepper: FC<SteeperProps> = ({ steps, currentStep }) => {
  return (
    <ProgressBarContainer>
      {steps.map((step, index) => {
        const status = index < currentStep ? 'completed' : index === currentStep ? 'current' : 'inactive';
        return (
          <Fragment key={index}>
            {index > 0 && <ProgressLine />} {/* Línea entre pasos */}
            <StepWrapper key={index}>
              <StepCircle $status={status}>
                {
                  status === 'completed'
                  ? <span>✓</span>
                  : <span>{index + 1}</span>
                }
              </StepCircle>
              <StepLabel $status={status}>{step}</StepLabel>
            </StepWrapper>
          </Fragment>
        );
      })}
    </ProgressBarContainer>
  );
};
